import { BubbleChart as IconBubbleChart, Event as IconEvent, Info as IconInfo, PrivacyTipOutlined as IconPrivacyTipOutlined } from '@mui/icons-material';
import TabActivities from 'Page/UsersProfile/Tabs/TabActivities/TabActivities';
import TabGeneral from 'Page/UsersProfile/Tabs/TabGeneral/TabGeneral';
import TabSecurity from 'Page/UsersProfile/Tabs/TabSecurity/TabSecurity';
import TabServices from 'Page/UsersProfile/Tabs/TabServices/TabServices';
import { generatePath, useParams } from 'react-router-dom';
import TestIds from 'Tests/TestIds';
import { TTabView } from '../Components/Shared/Tabs/Tabs';
import { PrivateRoutes } from '../Router/Routes';

interface Props {
  person: IPersonDetailed;
}

const useTabsUser = ({ person }: Props): TTabView[] => {
  const { accountCode, immutableId } = useParams<{
    accountCode: string;
    immutableId: string;
  }>();

  const getPath = (path: string) =>
    generatePath(path, {
      accountCode,
      immutableId
    });

  const tabs: TTabView[] = [
    {
      icon: <IconInfo />,
      path: PrivateRoutes.usersProfile.path,
      link: getPath(PrivateRoutes.usersProfile.path),
      title: 'profile.menu.general',
      component: <TabGeneral person={person} />,
      testid: TestIds.pages.profile.linkGeneral
    },
    {
      icon: <IconBubbleChart />,
      path: PrivateRoutes.usersProfileServices.path,
      link: getPath(PrivateRoutes.usersProfileServices.path),
      title: 'profile.menu.services',
      component: <TabServices person={person} />,
      testid: TestIds.pages.profile.linkServices
    },
    {
      icon: <IconEvent />,
      path: PrivateRoutes.usersProfileActivities.path,
      link: getPath(PrivateRoutes.usersProfileActivities.path),
      title: 'profile.menu.activities',
      component: <TabActivities person={person} />,
      testid: TestIds.pages.profile.linkActivities
    },
    {
      icon: <IconPrivacyTipOutlined />,
      path: PrivateRoutes.usersProfileSecurity.path,
      link: getPath(PrivateRoutes.usersProfileSecurity.path),
      title: 'profile.menu.security',
      component: <TabSecurity person={person} />,
      testid: TestIds.pages.profile.linkSecurity
    }
  ];

  return tabs;
};

export default useTabsUser;
